<template lang="pug">
  
	div#pesquisaCamada(:class="{ 'level-1': registro }")

		//- NÍVEL 0 - Campos da pesquisa e listagem de resgistros encontrados.

		div.float-box-view-level-0

			div.col-md-12.float-box-title
				h2.pull-left 
					i.mdi.mdi-magnify
					| Pesquisa

			alert.mb-0(msg="Não há camadas passíveis de pesquisa.", :visible="!pesquisaLiberada", type="warning")
			
			div.col-md-12.float-box-title-extras.filtro-pesquisa(v-show="pesquisaLiberada")

				form(@submit.prevent="validateAndSearch()")
					div.form-group
						
						label Camada:
						
						select.form-control.form-control-sm(@change="onCamadaChange()", v-model="camada", :disabled="!pesquisaLiberada"
							v-validate="'required'", name="camada")
							
							option(value="", disabled, selected) Selecionar
							option(v-for="camada in camadasPesquisaveis" :value="camada") {{ camada.nome }}
						
						input-errors(name="camada")

					div.form-group
						
						label Atributo:
						
						select.form-control.form-control-sm(:disabled="!pesquisaLiberada || !camada", v-model="atributo", @change="onAtributoChange()",
							v-validate="'required'", name="atributo")
							
							option(value="", disabled, selected, v-if="atributos && atributos.length > 0") Selecionar
							option(value="", disabled, v-if="!atributos || atributos.length === 0") Camada selecionada não possui atributos
							option(v-for="atributo in atributos", :value="atributo") {{ atributo.nome }}
						
						input-errors(name="atributo")

					div.form-group
						
						label Pesquisa:

						input.form-control.form-control-sm(type='text', v-model="filtro", v-validate="validator", 
							name="filtro", :disabled="!pesquisaLiberada || !atributo", v-if="!atributo || atributo.tipo !== TipoAtributoCamada.BOOLEANO")
						input-errors(name="filtro")

						select.form-control.form-control-sm(v-model="filtro", v-validate="'required'", 
							name="filtroBoolean", v-if="atributo && atributo.tipo === TipoAtributoCamada.BOOLEANO")
							
							option(value="", disabled, selected) Selecionar
							option(value="true") Sim
							option(value="false") Não
						
						input-errors(name="filtroBoolean")
					
					.row
						.col-12
							button.btn.btn-primary.btn-sm.float-right(type="button", @click="validateAndSearch()", :disabled="!pesquisaLiberada")
								i.mdi.mdi-magnify
								|  Pesquisa

							button.btn.btn-outline-secondary.btn-sm(type="button", @click="clean()", :disabled="!pesquisaLiberada")
								i.mdi.mdi-eraser
								|  Limpar
			
			div.float-box-content.content-pesquisa 

				listagem-registros(ref="listagemRegistros", 
						v-if="pesquisaEfetuada", 
						:registros="registrosPesquisa",
						@exibirRegistro="exibirRegistro",
						:showMarkers="true")

			div.float-box-footer(v-if="registrosPesquisa && registrosPesquisa.length > 0")
				
				paginacao(ref="paginacao", :total="paginacao.totalItens", :page-size="paginacao.itensPorPagina", 
					:onChange="alterarPagina", :options="paginationOptions")


		//- NÍVEL 1 - Visualização dos detalhes de um registro da camada, exibido quando 
		//- o usuário clica em um dos registros na listagem

		div.float-box-view-level-1

			visualizacao-registro-camada(
					:registro="registro", 
					v-if="registro", 
					@close="ocultarRegistro()", 
					:showReturnButton="true")

</template>

<script>

import { mapState } from 'vuex';

import camadasService from '@/services/camadasService';
import TipoAtributoCamada from '@/models/tipoAtributoCamada';

import EmptyResult from '@/components/utils/EmptyResult';
import Paginacao from '@/components/utils/Paginacao';
import ListagemRegistros from './ListagemRegistrosCamada';

import Alert from '@/components/utils/Alert';
import VisualizacaoRegistroCamada from '@/components/VisualizacaoRegistroCamada';
import markerStyles from '@/utils/markerStyles';

const PAGINA_INICIAL = 1;

export default {
	name: 'Pesquisa',

	components: { EmptyResult, ListagemRegistros, Paginacao, Alert, VisualizacaoRegistroCamada },

	componentOptions: {
		
		title: 'Pesquisa',

		actions: [
			[
				{
					name: 'Pesquisa',
					iconClass: 'mdi mdi-magnify',
					showView: true
				}
			]
		]
	},

	data () {
		return {
			camada: null,
			atributo: null,
			atributos: [],
			requestOptions: {
				lockElement: '#pesquisaCamada',
				lockMessage: 'Aguarde, buscando atributos.'
			},
			tipoAtributo: TipoAtributoCamada,
			filtro: null,
			registrosPesquisa: null,
			pesquisaEfetuada: false,
			paginacao: {
				itens: []
			},
			paginationOptions: {
				offset: 1,
				previousText: '«',
				nextText: '»',
				alwaysShowPrevNext: true
			},
			registro: null,
			TipoAtributoCamada: TipoAtributoCamada
		};
	},

	methods: {

		/**
		 * Evento de onChange no select de Camadas
		 */
		onCamadaChange () {

			this.atributo = null;
			this.filtro = null;

			this.cleanValidation();

			camadasService.findAtributos(this.camada.id, this.requestOptions,
				(result) => {
					this.atributos = result;
				}
			);
		},

		/**
		 * Evento de onChange no select de Atributos
		 */
		onAtributoChange () {

			this.filtro = null;
			this.cleanValidation();
		},

		/**
		 * Limpa o errosBag do validation
		 */
		cleanValidation () {

			setTimeout(() => {
				this.$validator.cleanErrors(['camada', 'atributo', 'filtro']);
			}, 100);
		},

		/**
		 * Limpa os campos de filtros
		 */
		clean () {

			this.camada = null;
			this.atributo = null;
			this.filtro = null;
			this.atributos = null;

			this.cleanValidation();
		},

		/**
		 * Realiza a validação do formulário de filtro e chama o serviço de pesquisar
		 */
		validateAndSearch () {
			
			this.$validator.validateAll().then(
				(result) => {
					
					if (result) {
						
						if (this.$refs.paginacao) {
							this.$refs.paginacao.setPage(PAGINA_INICIAL);
						}
						
						this.search(PAGINA_INICIAL);
					}
				}
			);
		},

		/**
		 * Dispara o serviço de pesquisar no servidor
		 */
		search (page) {
			
			let params = {
				pagina: page,
				camada: this.camada.id,
				atributo: this.atributo.id,
				q: this.filtro
			};

			camadasService.pesquisar(params, this.requestOptions,
				(data) => {
					this.paginacao = data;
					this.registrosPesquisa = data.itens;
					this.pesquisaEfetuada = true;
				}
			);

		},

		/**
		 * Mostra os detalhes do resultado selecionado.
		 */
		exibirRegistro (e) {
			
			this.registro = e.registro;

			this.$bus.$emit('mapa.addCoordinatePoint', {
				markerCode: 'RegistroCamada',
				lat: this.registro.centroid.coordinates[1],
				lng: this.registro.centroid.coordinates[0],
				markerStyle: markerStyles.registroCamada,
				center: true,
				fixed: true
			});
		},

		/**
		 * Oculta o registro exibido, retornando à listagem.
		 */
		ocultarRegistro (e) {
			
			this.$bus.$emit('mapa.removeCoordinatePoint', 'RegistroCamada');
			this.registro = null;
		},

		/**
		 * Pesquisa a pesquisa através da navegação pela paginação
		 */
		alterarPagina (page) {
			this.search(page);
		},

		/**
		 * Método de destruição do component (executado quando ele não é mais visível)
		 */
		beforeComponentHide () {

			if (this.$refs.listagemRegistros) {
				this.$refs.listagemRegistros.removerMarcador();
			}

			this.$bus.$emit('mapa.removeCoordinatePoint', 'RegistroCamada');
		},

		/**
		 * Método de inicialização do component (executado quando ele se torna visível)
		 */
		afterComponentShow () {
			this.$emit('ocultarRegistro');
		}
	},

	computed: {

		...mapState([
			'camadasOrdenadas'
		]),

		/**
		 * Retorna qual validação deve ser utilizada pelo validator
		 */
		validator () {
			
			let validator = 'required';

			if (!this.atributo) return validator;

			switch (this.atributo.tipo) {

			case this.tipoAtributo.TEXTO:
				validator = 'required';
				break;

			case this.tipoAtributo.DECIMAL:
				validator = 'required|decimal';
				break;

			case this.tipoAtributo.INTEIRO:
				validator = 'required|numeroInteiro';
				break;

			case this.tipoAtributo.DATA:
				validator = 'required|date_format:DD/MM/YYYY';
				break;
			}

			return validator;
		},

		camadasPesquisaveis () {
			
			return _.filter(this.camadasOrdenadas, (camada) => {
				return camada.possuiAtributosPublicos;
			});
		},

		pesquisaLiberada () {

			return this.camadasPesquisaveis && this.camadasPesquisaveis.length > 0;

		}
	}

};

</script>

<style lang="scss">

@import "../styles/variaveis";

$filtro-pesquisa-height: 290px;
$footer-result-height: 30px;

#pesquisaCamada {
	height: 100%;

	.filtro-pesquisa {
		height: 290px;
	}

	.float-box-content.content-pesquisa {
		top: $float-box-content-top + $filtro-pesquisa-height;
		padding-top: 5px;
		bottom: $footer-result-height;
	}

	ul {
		margin-bottom: 0;
	}
}
</style>



// WEBPACK FOOTER //
// Pesquisa.vue?2c010386